import Vue from 'vue'
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './styles/main.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
Vue.config.productionTip = false
Vue.use(Vuex);
Vue.use(VueRouter);
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
